<template>
  <button :class="classButton" type="button" @click="handleClick" :disabled="loading">
    <span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
    <i v-if="icon != '' && !loading" :class="icon"></i> {{ buttonText }}
  </button>
</template>

<script>
export default {
  props: {
    buttonText: {
      type: String,
      default: "Continue",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    classButton:
    {
      type: String,
      default: "btn btn-primary",
    },
    icon:{
      type: String,
      default: "",
    }
  },
  methods: {
    handleClick() {
      // Emit a custom event to notify parent component
      if (!this.loading) this.$emit("pressed");
    },
  },
};
</script>

<style scoped>
/*button {
    position: relative;
  }
  
  button.loading {
    cursor: not-allowed;
  }
  
  .spinner {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border: 4px solid rgba(0, 0, 0, 0.1);
    border-left-color: #3498db;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    animation: spin 1s linear infinite;
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }*/
</style>
